export default __webpack_public_path__ + "static/media/fancyfootwork.940bb45f.png";